import React from "react";
import Filter, { FilterProps } from "elements/Filter/Filter";
import { hasValue } from "utilities/filters/filters";
import { ActionFilterState } from "routes/Manage/Actions/QueryParam";

export const ActionFilter = (props: FilterProps<ActionFilterState>) => (
  <Filter {...props} />
);

export const actionFilterSelected = (
  filterValues: ActionFilterState
): boolean => {
  let filtersSelected = false;
  if (hasValue(filterValues, "action")) {
    filtersSelected = true;
  }

  return filtersSelected;
};
